import { useRef as G, useEffect as Q } from "react";
import { d as Z } from "./templateResolver-BchYA4i9.js";
import { u as ee } from "./loading-status-Bznbx7a4.js";
import { u as te } from "./use-definition-0yWcQDPI.js";
function re(t, e) {
  const { code: o, description: r } = e;
  return {
    ...t,
    code: o,
    description: r,
    status: ee(`guard-${o}`, r),
    execute: () => {
      var i;
      return t.error ? {
        success: !1,
        error: ((i = t.error) == null ? void 0 : i.message) || String(t.error) || "Unknown error"
      } : t.data && !t.isLoading ? { success: !0, data: t.data } : { success: !1, error: "" };
    }
  };
}
function Se(t, e) {
  const { initDefinitions: o, setEntitySchema: r, setEntityError: i, setAllComplete: s } = Z(), n = G(null), p = G(!1);
  Q(() => {
    if (!t || p.current)
      return;
    p.current = !0, o(t);
    const a = typeof e.workerURL == "string" ? e.workerURL : e.workerURL.href;
    return n.current = new Worker(a, { type: "module" }), n.current.onmessage = (l) => {
      const c = l.data;
      switch (c.type) {
        case "SCHEMA_READY":
          r(c.entity, c.schema);
          break;
        case "SCHEMA_ERROR":
          i(c.entity, c.error);
          break;
        case "ALL_COMPLETE":
          s();
          break;
      }
    }, n.current.postMessage({
      type: "TRANSFORM_ALL",
      definitions: t
    }), () => {
      n.current && (n.current.terminate(), n.current = null);
    };
  }, [t, e.workerURL]);
}
function ve(t) {
  return re(te(t), {
    code: "definition",
    description: "Definition"
  });
}
const g = "{{resolveFieldAccess}}";
function oe(t) {
  if (typeof t != "number" || !Number.isFinite(t) || t < 0)
    return;
  if (t >= 1 && Number.isInteger(t))
    return t;
  const e = t.toString().toLowerCase(), o = e.match(/e-(\d+)$/);
  if (o)
    return Number(o[1]);
  const [, r] = e.split(".");
  return r ? r.length : 0;
}
function ie(t) {
  return `{{(value, info) => {
		if (info?.userTyping) return info.input ?? String(value ?? "");
		if (
			value === null ||
			value === undefined ||
			value === "" ||
			value === "undefined" ||
			value === "null"
		)
			return "";
		const numericValue = Number(value);
		return Number.isFinite(numericValue)
			? numericValue.toFixed(${t})
			: String(value);
	}}}`;
}
function ne(t) {
  return t ? Array.isArray(t) ? [...t, g] : [t, g] : g;
}
const D = {
  varchar: {
    "x-component": "Input",
    "x-decorator": "FormItem"
  },
  citext: {
    "x-component": "Input",
    "x-decorator": "FormItem"
  },
  text: {
    "x-component": "Input.TextArea",
    "x-decorator": "FormItem",
    "x-component-props": {
      rows: 4
    }
  },
  int: {
    "x-component": "NumberPicker",
    "x-decorator": "FormItem"
  },
  decimal: {
    "x-component": "NumberPicker",
    "x-decorator": "FormItem",
    "x-component-props": {
      precision: 2
    }
  },
  boolean: {
    "x-component": "Switch",
    "x-decorator": "FormItem"
  },
  date: {
    "x-component": "DatePicker",
    "x-decorator": "FormItem"
  },
  time: {
    "x-component": "TimeField",
    "x-decorator": "FormItem"
  },
  timestamp: {
    "x-component": "DatePicker",
    "x-decorator": "FormItem",
    "x-component-props": {
      showTime: !0
    }
  },
  json: {
    "x-component": "Input.TextArea",
    "x-decorator": "FormItem",
    "x-component-props": {
      rows: 6
    }
  },
  jsonb: {
    "x-component": "ArrayTable",
    "x-decorator": "FormItem"
  },
  relation: {
    "x-component": "Select",
    "x-decorator": "FormItem"
  }
};
function d(t) {
  var e;
  return ((e = t.ui) == null ? void 0 : e.required) === !0;
}
function se(t) {
  return D[t] || D.varchar;
}
function C(t) {
  return typeof t == "object" && t !== null && "typeahead" in t;
}
function ae(t, e) {
  if (typeof t == "string") {
    if (t === "*")
      return `($deps[${e}] != null && $deps[${e}] !== "")`;
    const o = t.match(/^<(\d+(?:\.\d+)?)$/);
    if (o)
      return `($deps[${e}] != null && $deps[${e}] !== "" && Number($deps[${e}]) < ${o[1]})`;
    const r = t.match(/^>(\d+(?:\.\d+)?)$/);
    if (r)
      return `($deps[${e}] != null && $deps[${e}] !== "" && Number($deps[${e}]) > ${r[1]})`;
  }
  return `$deps[${e}] === ${JSON.stringify(t)}`;
}
function pe(t) {
  var e, o;
  return !!((e = t.ui) != null && e.options) && !C((o = t.ui) == null ? void 0 : o.options);
}
function le(t, e) {
  var n, p, a, l, c;
  const o = (n = e.ui) == null ? void 0 : n.options;
  if (!C(o))
    throw new Error(
      `Expected typeahead options for field "${t}"`
    );
  const r = o.typeahead.target, i = "name";
  return {
    type: "string",
    title: ((p = e.ui) == null ? void 0 : p.label) || t,
    required: d(e),
    "x-component": "RelationSelect",
    "x-decorator": "FormItem",
    "x-component-props": {
      entity: r,
      labelField: i,
      nameTemplate: "{name}",
      valueField: i,
      scalar: !0,
      multiple: ((a = e.ui) == null ? void 0 : a.multiple) === !0,
      placeholder: ((l = e.ui) == null ? void 0 : l.placeholder) || `Select ${((c = e.ui) == null ? void 0 : c.label) || t}...`,
      allowClear: !0
    }
  };
}
function ce(t) {
  return Array.isArray(t) ? t.map((e) => ({
    label: String(e),
    value: e
  })) : Object.entries(t).map(([e, o]) => ({
    label: String(o),
    value: e
  }));
}
function de(t, e) {
  var i, s;
  const o = ((i = e.ui) == null ? void 0 : i.columns) || [], r = {};
  return o.forEach((n, p) => {
    const a = n.type === "number" ? "NumberPicker" : "Input";
    r[`column_${p}`] = {
      type: "void",
      "x-component": "ArrayTable.Column",
      "x-component-props": {
        title: n.title
      },
      properties: {
        [n.key]: {
          type: n.type === "number" ? "number" : "string",
          "x-component": a,
          "x-decorator": "FormItem"
        }
      }
    };
  }), r.operations = {
    type: "void",
    "x-component": "ArrayTable.Column",
    "x-component-props": {
      title: "Actions",
      width: 80,
      align: "center"
    },
    properties: {
      item: {
        type: "void",
        "x-component": "FormItem",
        properties: {
          remove: {
            type: "void",
            "x-component": "ArrayTable.Remove"
          }
        }
      }
    }
  }, {
    type: "array",
    title: ((s = e.ui) == null ? void 0 : s.label) || t,
    required: d(e),
    "x-component": "ArrayTable",
    "x-decorator": "FormItem",
    "x-component-props": {
      size: "small",
      bordered: !0
    },
    items: {
      type: "object",
      properties: r
    },
    properties: {
      addition: {
        type: "void",
        title: "Add Row",
        "x-component": "ArrayTable.Addition"
      }
    }
  };
}
function N(t, e) {
  var r, i, s;
  const o = e.target || t;
  return {
    type: "array",
    title: ((r = e.ui) == null ? void 0 : r.label) || t,
    required: d(e),
    "x-component": "SubformTable",
    "x-decorator": "FormItem",
    "x-decorator-props": {
      gridSpan: 4
    },
    "x-component-props": {
      entity: o,
      disableAddRow: ((i = e.ui) == null ? void 0 : i.disableAddRow) === !0,
      enableCsvExport: ((s = e.ui) == null ? void 0 : s.enableCsvExport) === !0
    }
  };
}
function ue(t, e) {
  var r;
  const o = e.target || t;
  return {
    type: "array",
    title: ((r = e.ui) == null ? void 0 : r.label) || t,
    required: d(e),
    "x-component": "InlineSubform",
    "x-decorator": "FormItem",
    "x-decorator-props": {
      gridSpan: 4
    },
    "x-component-props": {
      entity: o
    }
  };
}
function W(t, e) {
  var p, a, l, c, u, f;
  const o = e.target || t, r = ((p = e.ui) == null ? void 0 : p.multiple) === !0, n = {
    entity: o,
    labelField: "name",
    nameTemplate: "{name}",
    valueField: e.joinColumn ?? "id",
    multiple: r,
    placeholder: ((a = e.ui) == null ? void 0 : a.placeholder) || `Select ${((l = e.ui) == null ? void 0 : l.label) || t}...`,
    allowClear: !0
  };
  return e.joinColumn && (n.joinColumn = e.joinColumn), (c = e.ui) != null && c.filter && (n.filter = e.ui.filter), (u = e.ui) != null && u.dataSource && (n.dataSource = e.ui.dataSource), {
    type: "string",
    title: ((f = e.ui) == null ? void 0 : f.label) || t,
    required: d(e),
    "x-component": "RelationSelect",
    "x-decorator": "FormItem",
    "x-component-props": n
  };
}
function J(t, e) {
  var i, s, n, p, a, l, c, u, f, x, y, b, F, v, $, T, A, I, k, E, w, j, R, O, P, _, L, M, q;
  if (e.type === "jsonb" && ((i = e.ui) != null && i.columns))
    return de(t, e);
  if (C((s = e.ui) == null ? void 0 : s.options))
    return le(t, e);
  if (e.type === "text" && ((n = e.ui) == null ? void 0 : n.control) === "call_notes")
    return {
      type: "string",
      title: ((p = e.ui) == null ? void 0 : p.label) || t,
      required: d(e),
      "x-component": "CallNotesField",
      "x-decorator": "FormItem",
      "x-component-props": {
        rows: 4
      }
    };
  if (e.type === "json" && ((a = e.ui) == null ? void 0 : a.control) === "table") {
    const m = (l = e.ui) == null ? void 0 : l.fields, h = m ? Object.entries(m).map(([U, X]) => ({
      key: U,
      title: X.label ?? U
    })) : void 0;
    return {
      type: "array",
      title: ((c = e.ui) == null ? void 0 : c.label) || t,
      required: d(e),
      "x-component": "JsonTable",
      "x-decorator": "FormItem",
      ...h ? { "x-component-props": { columns: h } } : {}
    };
  }
  if (e.type === "json" && ((u = e.ui) == null ? void 0 : u.control) === "link")
    return {
      type: "object",
      title: ((f = e.ui) == null ? void 0 : f.label) || t,
      required: d(e),
      "x-component": "LinkField",
      "x-decorator": "FormItem"
    };
  if ((e.type === "json" || e.type === "jsonb") && ((x = e.ui) == null ? void 0 : x.control) === "json")
    return {
      type: "object",
      title: ((y = e.ui) == null ? void 0 : y.label) || t,
      required: d(e),
      "x-component": "JsonField",
      "x-decorator": "FormItem"
    };
  if ((e.type === "json" || e.type === "jsonb") && ((b = e.ui) == null ? void 0 : b.control) === "esign")
    return {
      type: "object",
      title: ((F = e.ui) == null ? void 0 : F.label) || t,
      required: d(e),
      "x-component": "EsignField",
      "x-decorator": "FormItem"
    };
  if (((v = e.ui) == null ? void 0 : v.control) === "file")
    return {
      type: "object",
      title: (($ = e.ui) == null ? void 0 : $.label) || t,
      required: d(e),
      "x-component": "FileUpload",
      "x-decorator": "FormItem",
      "x-component-props": {
        maxCount: 1
      }
    };
  if (e.type === "relation" && e.relation === "one-to-one" && e.target && ((T = e.ui) == null ? void 0 : T.control) === "entity")
    return ue(t, e);
  if (e.type === "relation" && e.target && ((A = e.ui) == null ? void 0 : A.control) === "entity")
    return N(t, e);
  if (e.type === "relation" && e.target && ((I = e.ui) == null ? void 0 : I.control) === "select")
    return W(t, e);
  if (e.type === "relation" && e.relation === "one-to-many" && e.target)
    return N(t, e);
  if (e.type === "relation" && e.relation === "many-to-one" && e.target)
    return W(t, e);
  const o = se(e.type), r = {
    type: "string",
    title: ((k = e.ui) == null ? void 0 : k.label) || t,
    required: d(e),
    ...o
  };
  if (pe(e) && ((E = e.ui) != null && E.options)) {
    const m = ce(
      e.ui.options
    );
    ((w = e.ui) == null ? void 0 : w.control) === "checkbox" ? r["x-component"] = "Checkbox.Group" : ((j = e.ui) == null ? void 0 : j.control) === "radio" ? r["x-component"] = "ClearableRadioGroup" : ((R = e.ui) == null ? void 0 : R.control) === "select" ? r["x-component"] = "Select" : r["x-component"] = m.length <= 4 ? "ClearableRadioGroup" : "Select", ((O = e.ui) == null ? void 0 : O.multiple) === !0 && (r.type = "array", r.default = [], r["x-component"] === "Select" && (r["x-component-props"] = {
      ...r["x-component-props"],
      mode: "multiple"
    })), r.enum = m;
  }
  if (r["x-component"] === "Select" && (r["x-component-props"] = {
    ...r["x-component-props"],
    allowClear: ((P = e.ui) == null ? void 0 : P.allowClear) ?? !0
  }), (_ = e.ui) != null && _.placeholder && (r["x-component-props"] = {
    ...r["x-component-props"],
    placeholder: e.ui.placeholder
  }), (L = e.ui) != null && L.mask && (r["x-component-props"] = {
    ...r["x-component-props"],
    mask: e.ui.mask
  }), e.type === "time" && (r["x-component-props"] = {
    ...r["x-component-props"],
    use12Hours: ((M = e.ui) == null ? void 0 : M.use12Hours) !== !1
  }), e.type === "decimal") {
    const m = oe((q = e.ui) == null ? void 0 : q.precision), h = typeof m == "number" ? m : 2;
    r["x-component-props"] = {
      ...r["x-component-props"],
      precision: h,
      formatter: ie(h)
    };
  }
  return r;
}
function z(t, e) {
  var o, r, i, s, n, p, a, l, c;
  if (((o = e.ui) == null ? void 0 : o.default) !== void 0 && t.default === void 0 && (t.default = e.ui.default), t["x-decorator-props"] = {
    ...t["x-decorator-props"],
    gridSpan: ((r = e.ui) == null ? void 0 : r.colSpan) ?? ((i = t["x-decorator-props"]) == null ? void 0 : i.gridSpan) ?? 1,
    tooltip: (s = e.ui) == null ? void 0 : s.note
  }, ((n = e.ui) == null ? void 0 : n.control) === "list" && (t["x-decorator"] = "AlertFormItem", t["x-decorator-props"] = {
    ...t["x-decorator-props"],
    alert: e.ui.alert || "info",
    list: e.ui.options
  }), (p = e.ui) != null && p.hidden && (t["x-display"] = "hidden"), (a = e.ui) != null && a.disabled && (t["x-disabled"] = !0), (l = e.ui) != null && l.visibleWhen && !((c = e.ui) != null && c.hidden)) {
    const u = Array.isArray(e.ui.visibleWhen) ? e.ui.visibleWhen : [e.ui.visibleWhen], f = u.map((b) => b.field), y = u.map(
      (b, F) => ae(b.value, F)
    ).join(" || ");
    t["x-reactions"] = {
      dependencies: f,
      fulfill: {
        state: {
          visible: `{{${y}}}`,
          required: `{{(${y}) && ${JSON.stringify(d(e))}}}`
        }
      }
    };
  }
  return t["x-reactions"] = ne(t["x-reactions"]), t;
}
const fe = /* @__PURE__ */ new Set([
  "id",
  "created_on",
  "created_by",
  "updated_on",
  "updated_by",
  "deleted",
  "archived"
]);
function S(t) {
  return t.toLowerCase().replace(/[^a-z0-9]+(.)/g, (e, o) => o.toUpperCase()).replace(/[^a-z0-9]/gi, "");
}
function B(t, e) {
  return !fe.has(t);
}
function H(t, e) {
  const o = {};
  for (const r of t) {
    const i = e[r];
    if (!i || !B(r)) continue;
    const s = J(r, i);
    z(s, i), o[r] = s;
  }
  return o;
}
const K = 4;
function me(t, e, o) {
  var i, s;
  let r = 0;
  for (const n of t) {
    const p = ((s = (i = e[n]) == null ? void 0 : i.ui) == null ? void 0 : s.colSpan) ?? 1;
    r + p > o && r > 0 && (r = 0), r += p;
  }
  return r === 0 ? 0 : Math.max(0, o - r);
}
function xe(t) {
  var e;
  return t.type === "relation" && t.relation === "one-to-one" && ((e = t.ui) == null ? void 0 : e.control) === "entity" && !!t.target;
}
function V(t, e) {
  const o = {};
  return t.forEach((r, i) => {
    const s = r.name ? S(r.name) : `section${i}`, n = [], p = [];
    for (const a of r.fields) {
      const l = e[a];
      l && xe(l) ? p.push(a) : n.push(a);
    }
    if (r.name && (o[`${s}Title`] = {
      type: "void",
      "x-component": "SectionTitle",
      "x-component-props": { title: r.name }
    }), n.length > 0) {
      const a = r.maxColumns ?? K, l = H(n, e), c = me(
        n,
        e,
        a
      ), u = {};
      for (let x = 0; x < c; x++)
        u[`${s}Spacer${x}`] = {
          type: "void",
          "x-decorator": "FormItem",
          "x-decorator-props": { gridSpan: 1, label: " " },
          "x-component": "div"
        };
      const f = { ...l, ...u };
      Object.keys(f).length > 0 && (o[`${s}Grid`] = {
        type: "void",
        "x-component": "FormGrid",
        "x-component-props": {
          maxColumns: a,
          minColumns: 2
        },
        properties: f
      });
    }
    for (const a of p) {
      const l = e[a];
      if (!l || !B(a)) continue;
      const c = J(a, l);
      z(c, l), o[a] = c;
    }
  }), o;
}
function Y(t, e) {
  if ("sections" in t && t.sections)
    return V(t.sections, e);
  if ("fields" in t && t.fields) {
    const o = S(t.name || "tab"), r = H(t.fields, e);
    return Object.keys(r).length === 0 ? {} : {
      [`${o}Grid`]: {
        type: "void",
        "x-component": "FormGrid",
        "x-component-props": {
          maxColumns: K,
          minColumns: 2
        },
        properties: r
      }
    };
  }
  return {};
}
function be(t, e) {
  const o = {};
  return t.forEach((r) => {
    const i = S(r.name || "tab"), s = Y(r, e);
    o[i] = {
      type: "void",
      "x-component": "MantineFormTab.TabPane",
      "x-component-props": {
        tab: r.name
      },
      properties: s
    };
  }), {
    tabs: {
      type: "void",
      "x-component": "MantineFormTab",
      properties: o
    }
  };
}
function ye(t) {
  var s;
  const e = (s = t.ui) == null ? void 0 : s.form, { columns: o } = t;
  if (!e || !e.tabs && !e.sections)
    throw new Error(
      `Invalid form config for "${t.name}": must have either tabs or sections`
    );
  let r;
  if (e.tabs && e.tabs.length > 0)
    e.tabs.length === 1 ? r = Y(e.tabs[0], o) : r = be(e.tabs, o);
  else if (e.sections && e.sections.length > 0)
    r = V(e.sections, o);
  else
    throw new Error(
      `Invalid form config for "${t.name}": tabs or sections array is empty`
    );
  return {
    type: "object",
    properties: {
      layout: {
        type: "void",
        "x-component": "FormLayout",
        "x-component-props": {
          layout: "vertical",
          colon: !1
        },
        properties: r
      }
    }
  };
}
function $e(t) {
  const e = {};
  for (const [o, r] of Object.entries(t))
    e[o] = ye(r);
  return e;
}
export {
  fe as B,
  D as C,
  ve as a,
  $e as b,
  ce as c,
  J as d,
  z as e,
  re as f,
  se as g,
  pe as h,
  ye as t,
  Se as u
};
